
const PHP_STOCK_URL = 'https://challwashop.com/bigheadperu.myshopify.com.stock.php';

const LOCATIONS = {
    '57558728913': 'Central',
    '68737401041': 'San Isidro',
    '67999334609': 'Chacarilla', 
    '71483752657': 'Mega Plaza',
    '61141221585': 'Miraflores',
    '68043505873': 'Jockey Volcom',
    '72112996561': 'Trujillo'

};

const CENTRAL_LOCATION_ID = '57558728913';
const PICKUP_LOCATIONS = Object.fromEntries(
    Object.entries(LOCATIONS).filter(([id]) => id !== CENTRAL_LOCATION_ID)
);

// Cache simple
const stockCache = new Map();
const CACHE_DURATION = 30000; // 30 segundos

function getCachedStock(variantId) {
    const cached = stockCache.get(variantId);
    if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
        return cached.data;
    }
    return null;
}

function setCachedStock(variantId, data) {
    stockCache.set(variantId, {
        data: data,
        timestamp: Date.now()
    });
    
    if (stockCache.size > 200) {
        const oldestKey = stockCache.keys().next().value;
        stockCache.delete(oldestKey);
    }
}

// Función principal - UNA SOLA CONSULTA
async function checkSimpleAvailability(productId, variantId) {
    if (!variantId || variantId === 'undefined') {
        return;
    }
    
    // Verificar cache
    const cachedData = getCachedStock(variantId);
    if (cachedData) {
        updateAllUI(productId, cachedData);
        return;
    }
    
    try {
        // Preparar consulta con todas las ubicaciones
        const requestData = [];
        
        // Envío a domicilio
        requestData.push({
            variant_id: variantId,
            quantity: 1,
            title: 'Stock Check - Delivery',
            vendor: LOCATIONS[CENTRAL_LOCATION_ID],
            variant_title: CENTRAL_LOCATION_ID,
            product_title: 'Product',
            id: variantId,
            key: `${variantId}-delivery`
        });
        
        // Tiendas pickup
        Object.entries(PICKUP_LOCATIONS).forEach(([locationId, locationName]) => {
            requestData.push({
                variant_id: variantId,
                quantity: 1,
                title: 'Stock Check - Pickup',
                vendor: locationName,
                variant_title: locationId,
                product_title: 'Product',
                id: variantId,
                key: `${variantId}-${locationId}`
            });
        });
        
        // Una sola llamada HTTP
        const response = await fetch(PHP_STOCK_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const results = await response.json();
        
        // Procesar respuesta
        const stockData = {
            delivery: false,
            pickup: {}
        };
        
        Object.keys(PICKUP_LOCATIONS).forEach(locationId => {
            stockData.pickup[locationId] = false;
        });
        
        results.forEach((result, index) => {
            const originalRequest = requestData[index];
            const locationId = originalRequest.variant_title;
            const isAvailable = result.status === 'Ok';
            
            if (locationId === CENTRAL_LOCATION_ID) {
                stockData.delivery = isAvailable;
            } else if (PICKUP_LOCATIONS[locationId]) {
                stockData.pickup[locationId] = isAvailable;
            }
        });
        
        // Guardar en cache y actualizar UI
        setCachedStock(variantId, stockData);
        updateAllUI(productId, stockData);
        
    } catch (error) {
        // Error: marcar todo como no disponible
        const errorData = {
            delivery: false,
            pickup: {}
        };
        Object.keys(PICKUP_LOCATIONS).forEach(locationId => {
            errorData.pickup[locationId] = false;
        });
        updateAllUI(productId, errorData);
    }
}

// Actualizar UI
function updateAllUI(productId, stockData) {
    updateDeliveryUI(productId, stockData.delivery);
    
    Object.entries(PICKUP_LOCATIONS).forEach(([locationId, locationName]) => {
        const available = stockData.pickup[locationId] || false;
        updateStoreUI(productId, locationId, locationName, available);
    });
}

function updateDeliveryUI(productId, available) {
    const deliveryEl = document.getElementById(`delivery-${productId}`);
    if (deliveryEl) {
        if (available) {
            deliveryEl.className = 'option-card delivery-option available';
            deliveryEl.querySelector('.delivery-status').textContent = 'Disponible';
        } else {
            deliveryEl.className = 'option-card delivery-option unavailable';
            deliveryEl.querySelector('.delivery-status').textContent = 'No disponible';
        }
    }
}

function updateStoreUI(productId, locationId, locationName, available) {
    const pickupEl = document.getElementById(`pickup-${locationId}-${productId}`);
    if (pickupEl) {
        if (available) {
            pickupEl.className = 'option-card pickup-option available';
            pickupEl.querySelector('.pickup-status').textContent = 'Disponible';
        } else {
            pickupEl.className = 'option-card pickup-option unavailable';
            pickupEl.querySelector('.pickup-status').textContent = 'No disponible';
        }
    }
}

function findVariantId(productId) {
    const variantSelector = document.querySelector('select[name="id"], input[name="id"]:checked');
    if (variantSelector && variantSelector.value) {
        return variantSelector.value;
    }
    
    const productJson = document.querySelector(`[id*="ProductJson-${productId}"], [id*="ProductJson"]`);
    if (productJson) {
        try {
            const product = JSON.parse(productJson.textContent);
            if (product.variants && product.variants.length > 0) {
                return product.variants[0].id.toString();
            }
        } catch (e) {
            // Ignore parsing errors
        }
    }
    
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');
    if (variantFromUrl) {
        return variantFromUrl;
    }
    
    return null;
}

// Event listeners
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        const containers = document.querySelectorAll('.delivery-availability');
        
        containers.forEach(container => {
            const productId = container.dataset.productId;
            let variantId = container.dataset.variantId;
            
            if (!variantId || variantId === 'undefined') {
                variantId = findVariantId(productId);
                if (variantId) {
                    container.dataset.variantId = variantId;
                }
            }
            
            if (productId && variantId) {
                checkSimpleAvailability(productId, variantId);
            }
        });
    }, 1500);
});

document.addEventListener('change', function(e) {
    if (e.target.matches('[name="id"]')) {
        const newVariantId = e.target.value;
        if (newVariantId) {
            const containers = document.querySelectorAll('.delivery-availability');
            containers.forEach(container => {
                const productId = container.dataset.productId;
                checkSimpleAvailability(productId, newVariantId);
            });
        }
    }
});

document.addEventListener('click', function(e) {
    if (e.target.matches('.variant-option, .swatch, .variant-button') || 
        e.target.closest('.variant-option, .swatch, .variant-button')) {
        setTimeout(() => {
            const form = e.target.closest('form') || e.target.closest('.product-form');
            const variantInput = form ? form.querySelector('[name="id"]') : null;
            if (variantInput && variantInput.value) {
                const containers = document.querySelectorAll('.delivery-availability');
                containers.forEach(container => {
                    const productId = container.dataset.productId;
                    checkSimpleAvailability(productId, variantInput.value);
                });
            }
        }, 300);
    }
});

window.checkSimpleAvailability = checkSimpleAvailability;